import React, { FC, useEffect, useCallback, useMemo, useState } from 'react';
import styled, { useTheme, css, createGlobalStyle, ThemeProvider } from 'styled-components';
import {
  FlexBox,
  useIsMobile,
  useBreakpoint,
  ModalMenuContextMobileUI,
  LinkColumn,
  Outer,
  SwitcherContentContainer,
  TabsSwitcherWrapper,
  CustomModalMenuMobileUI,
  Colors,
  SwitcherItem,
  SwitcherContainer,
  LinkBoxWrapper
} from '@brg/ui';
import './ModalMenuContextsMobile.css';
// import { LinkColumn, Outer, SwitcherContentContainer, TabsSwitcherWrapper } from '@brg/ui/dist/ui-modal_menu_context_mobile/component/styled';
// import { TagsSearchScrollWrapper } from '@brg/tags/dist/modals/selectTagsModal/styles.mobile';

import { AuthXService, bProfile, useProfile } from '@brg/auth';
import { ApplicationShared, bURL, LayoutConst, useModal } from 'core';
import { AppTester } from 'supporting';
import { NavbarWidget } from 'shared/components/__FOX__/NAV/src';
import { consoleSearch } from 'shared/helpers/consoleSearch';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import SelectTagsModalContainer from 'shared/modals/selectTagsModal/selectTagsModalContainer';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HseContextSelector } from "../reducers/hseCurrentContext";
import scrollElementIntoView from "../utils/scrollElementIntoView";
import { ExploreButtonFilled } from 'shared/pages/explore/styles';
import useSplitTagsConfig from "../hooks/useSplitTagsConfig";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { useGetMobileMenuSettings } from "../components/navigationSystem/useGetMobileMenuSettings";
import { useContextLinksNew } from "../components/navigationSystem/context/useContextLinksNew";
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { API } from "@brg/api";
import { COUNTRIES } from "../components/navigationSystem/tabs/useDafesTabs";
import { ModalMenuKiiidsCollectionTab } from './ModalMenuKiiidsCollectionTab';
import { createThemeByColor } from 'shared/helpers/coloring';

const TagsSearchScrollWrapper = styled(FlexBox)`
  //height: 100vh;
  height: 100%;
  overflow-y: overlay;
  display: block;
  padding-bottom: 50px !important;

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }
`;

export const SearchWrapper = styled(FlexBox)`
  padding: 16px 16px 0px;

  .search-flex-wrapper {
    height: 40px !important;
  }

  .main-searchbar-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 44px !important;
    height: 44px !important;
  }

  .main-searchbar-input-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    padding: 15px 10px 13px 16px !important;
  }

  .icon-wrapper {
    div {
      display: flex;
      height: 100%;
      align-items: center;
    }
  }

  .dropdown-container {
    .search-tabs-wrapper {
      width: 100%;
    }
  }

  .main-searchbar-wrapper__vertical,
  .main-searchbar-wrapper__vertical .main-searchbar-input-wrapper,
  .main-searchbar-wrapper__vertical input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 24px !important;
    height: 24px !important;
  }

  .main-searchbar-results-wrapper {
    z-index: 99999;
    width: 100%;
  }

  .main-searchbar_item {
    z-index: 99999;
    width: 100%;
  }


  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px 16px 0 16px !important;
  }

`;

export const SearchWrapperMobile = styled(FlexBox)`
  padding: 10px 10px 10px;

  .main-searchbar-wrapper, .main-searchbar-input-wrapper, input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 40px !important;
    height: 40px !important;
  }

  .main-searchbar-wrapper__vertical,
  .main-searchbar-wrapper__vertical .main-searchbar-input-wrapper,
  .main-searchbar-wrapper__vertical input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 24px !important;
    height: 24px !important;
  }

  .main-searchbar-results-wrapper {
    z-index: 99999;
    width: 100%;
  }

  .main-searchbar_item {
    z-index: 99999;
    width: 100%;
  }

`;

const TextBox = styled(FlexBox)`
  row-gap: 16px;
  //&:last-child {
  //    margin-bottom: 150px;
  //}
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
  @media (min-width: ${LayoutConst.screen.s}px) {
    row-gap: 24px;
  }
`;

export const TextItem = styled.span<{ color?: string }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  ${({ color }) => color ? css`
    color: ${color};
  ` : null};

  @media (min-width: ${LayoutConst.screen.s}px) {
    font-size: 34px;
    line-height: 41px;
    letter-spacing: -0.02em;
  }
`;

const CreateButtonWrapper = styled(FlexBox)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
  height: 76px;
  background-color: #f2f2f2;
  padding: 16px 16px 24px 16px;

  button {
    height: 36px !important;
    width: 100%;
    max-width: 100% !important;
    margin: 0 !important;
  }
`;

const BodyLock = createGlobalStyle`
  body {
    overflow-y: hidden !important;
    position: fixed;
  }
`

const Wrapper = styled.div<{ maxHeight?: number, variant?: 'menuLikeOnGallllery' }>`
  height: 100%;

  .dropdown-list-item, .sc-item {
    border-bottom: 1px solid rgb(205, 205, 205);
  }

  ${Outer} {
    height: calc(100% - 48px);
    z-index: 200001;
  }
;

  ${LinkBoxWrapper}{
  margin-top: ${p => p.variant === 'menuLikeOnGallllery' && '27px'};
  }

  ${LinkColumn} {
    max-height: calc(100vh - ${({ maxHeight }) => maxHeight || 0}px);
    margin-bottom: 0 !important;
  }

  ${SwitcherContentContainer} {
    border-bottom: 1px solid #CDCDCD;
    height: calc(100% - 20px);
    background-color: ${p => p.variant === 'menuLikeOnGallllery' ? '#E7E7E7' : p.theme.app.backgroundColor};

    .sc-item {
      z-index: 0;
    }

    .sc-item:last-child {
      z-index: 0;
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '16px'};

      @media (max-width: ${LayoutConst.screen.s}px){
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};
      }
    }

    a {
      border-bottom: ${p => p.variant === 'menuLikeOnGallllery' ? '1px solid #CDCDCD' : 'none'};

      &:not(:last-child) {
        margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '10px'} !important;
      }

      .sc-dropdown-item, .sc-item{
          margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '16px'};
          padding-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '12px'};
          min-height: ${p => p.variant === 'menuLikeOnGallllery' && '35px'};

          &:last-child {
            margin-bottom: 0 !important;
          }

          @media (max-width: ${LayoutConst.screen.s}px) {
            margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};

            &:not(:last-child) {
              margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '10px'} !important;
            }
          }
      }

          @media (max-width: ${LayoutConst.screen.s}px) {
            &:not(:last-child) {
              margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '7.5px'} !important;
            }
          }
    }
  }

  ${TagsSearchScrollWrapper} {
    height: 100%;
  }

  ${SwitcherContainer} {
    border-bottom: ${p => p.variant === 'menuLikeOnGallllery' ? '1px solid #CDCDCD' : 'none'};
    max-height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    min-height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    margin-top: ${p => p.variant === 'menuLikeOnGallllery' && '8px'};

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    min-height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    }
  }

  ${TabsSwitcherWrapper} {
    height: 100%;
    
    >div >div {
      color: ${p => p.variant === 'menuLikeOnGallllery' && '#909090'};
    }

    &, & .active {
      background-color: ${p => p.variant === 'menuLikeOnGallllery' ? '#E7E7E7' : p.theme.app.backgroundColor};
    }
    .active {
      color: ${p => p.variant === 'menuLikeOnGallllery' && '#151515'};
      border-bottom: 2px solid ${p => p.theme.navigationBar.mobileMenu.item.colorActive};
    }
  }

  .sc-dropdown-item, .sc-item {
    margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '0'}; 

    div {
      font-size: 17px;
      line-height: 22px;
    }

    @media (min-width: ${LayoutConst.screen.s}px) {
      border: none;
    } 
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};
      div {
        font-size: 15px;
        line-height: 20px;
        padding-left: ${p => p.variant === 'menuLikeOnGallllery' && '12px'};
      }
    }
  }
`

/**
 * Модалка для мобильного меню
 * @param props
 * @constructor
 */
export const ModalMenuContextMobileNew: FC<{
  visible?: boolean,
  hseUrls?: any[],
  closeMenu?: () => void,
}> = ({
  hseUrls,
  visible,
  closeMenu,
}) => {

  const { t, i18n: { language } } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const is470 = useBreakpoint(470);
  const isHSEDesign = AppTester.isHSEDesign();
  const isAcademy = AppTester.isAcademy();
  const isDeziiignEssential = AppTester.isDeziiignEssential();
  const isGeograffee = AppTester.isGeograffee();
  const isDvaDesign = AppTester.isDvaDesign();
  const isMedia = AppTester.isMediiia();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isDafes = AppTester.isGeoDafes();
  const isLPU = AppTester.isLPUDesign();
  const isStartHSE = AppTester.isStartHSE();
  const { anchorLinks: anchorLinksRaw } = useSelector(HseContextSelector);
  const profile = useProfile();

  const theme1 = useTheme();

  const anchorLinks: any[] = useMemo(() => {
    //@ts-ignore
    return anchorLinksRaw.map(({ anchorText, postId }) => ({
      //@ts-ignore
      title: anchorText,
      name: anchorText,
      content: anchorText,
      value: '#',
      ctx: '',
      active: false,
      external: false,
      action: (e: any) => {
        closeMenu?.();
        const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
        if (element) {
          setTimeout(() => {
            scrollElementIntoView(element, -70);
          }, 300)
        }
      }
    }))
  }, [location, language, anchorLinksRaw])

  const { links: mainLinks } = useContextLinksNew();
  const rightLinks = useGetFilteredTabs(closeMenu);
  const filteredRightLinks = useMemo(() => isDvaDesign ? anchorLinks : rightLinks, [anchorLinks, isDvaDesign, rightLinks])

  const isModer = useMemo(() => (profile && bProfile.isModer(profile)), [profile])
  const filteredMainLinks = useMemo(() => isDvaDesign || isLPU || (isGalllleryArt && !isModer) ? [] : mainLinks, [isDvaDesign, isGalllleryArt, isLPU, isModer, mainLinks]);
  const noDropdown = /*isOnlines || isAgeytomesh || AppTester.isSchool()*/ true;

  const dropdownIsOpen = (isDeziiignEssential || isGeograffee) && !isAcademy
  const { shouldDisplaySplitTags } = useSplitTagsConfig();

  const lowerHseUrls = useMemo(() => hseUrls?.map(url => ({ ...url, title: url?.title?.toLowerCase() })), [hseUrls]);

  const {
    hiddenTabs,
    tabOrder,
    activeTab: initialTab,
    competenciesTabName,
    tagsTabName
  } = useGetMobileMenuSettings(filteredMainLinks, filteredRightLinks)

  const [activeTabState, setActiveTabState] = useState(initialTab);

  const ShouldDisplaySearchBar = getShouldDisplaySearch(activeTabState)

  const hasScroll = useMemo(() => {
    return shouldDisplaySplitTags && ((isHSEDesign && !!hseUrls?.length) || !!anchorLinks?.length);
  }, [shouldDisplaySplitTags, hseUrls, anchorLinks]);

  useEffect((): void => { // запрещаем общий скролл, чтобы шапка не скроллилась
    const body = document.querySelector('body');
    if (body) {
      if (visible) {
        body.style.overflow = "hidden";
      }
      //@ts-ignore
      return () => {
        body.style.overflow = "auto";
      }
    }
  }, [visible])

  const countriesTab = useMemo(() => {
    if (!isDafes) {
      return null;
    }
    const tr = API.lang(COUNTRIES, language);

    return {
      countries: {
        key: 'countries',
        name: language === 'en' ? 'Countries' : 'Страны',
        links: tr.map((item:any) => ({
          title: item.name,
          name: item.name,
          content: item.name,
          value: '#',
          ctx: '',
          active: false,
          external: false,
          isTeam: true,
          action: (e: any) => {
            closeMenu?.();
            history.push(CreateLinkTo.country(item.value))
          }
        }))
      }
    };
  }, [language])

  const customTabs = useMemo(() => {
    return {
      competencies: {
        key: 'competencies',
        name: competenciesTabName,
        component: <SelectTagsModalContainer
          protectedTags={[]}
          isMobileMenu
          onClose={closeMenu}
          mode={'link'}
          hasEduTags
        />,
      },
      ...countriesTab,
      ...(anchorLinks.length && {
        anchors: {
          key: 'anchors',
          name: language === 'en' ? 'Navigation' : 'Навигация',
          links: anchorLinks,
        },
      }),
    }
  }, [anchorLinks, competenciesTabName, countriesTab, language])

  const createButton = useMemo(() => {
    if (isMedia && is470) {
      return (
        <CreateButtonWrapper
          onClick={() => history.push(CreateLinkTo.projectCreate())}
        >
          <ExploreButtonFilled>{t('nav.create_project')}</ExploreButtonFilled>
        </CreateButtonWrapper>
      )
    }
  }, [isMedia, history, t, is470])

  // TODO жесткий временный костыль на скролл табов
  const maxHeight = useMemo(() => {
    return 48 + 36 + 26 + (ShouldDisplaySearchBar ? 60 : 0) + (createButton ? 76 : 0) + 110
  }, [ShouldDisplaySearchBar, createButton])

  if (!visible) {
    return null;
  }
  console.log('activeTabState:', activeTabState);
  return (
    <ThemeProvider theme={theme1}>
    <Wrapper maxHeight={maxHeight} variant={isBooksGallllery ? 'menuLikeOnGallllery' : undefined}>
      <ModalMenuContextMobileUI
        hasScroll={hasScroll}
        hasNoDropDown={Boolean(noDropdown)}
        isOpenedDropDown={dropdownIsOpen}
        tabOrder={tabOrder}
        mainLinks={filteredMainLinks}
        customTabNames={{
          tags: tagsTabName,
          laboratory: t('mobile_menu.laboratory'),
          menu: t('mobile_menu.menu'),
          main: isBooksGallllery ? t('mobile_menu.catalog') : t('mobile_menu.main'),
        }}
        hiddenTabs={hiddenTabs}
        leftLinks={[]}
        rightLinks={filteredRightLinks}
        //@ts-ignore
        dropdownLinks={isHSEDesign ? lowerHseUrls : undefined}
        tags={
          <SelectTagsModalContainer
            protectedTags={[]}
            isMobileMenu
            mode={'link'}
            onClose={closeMenu}
            {...(shouldDisplaySplitTags && !isStartHSE && {
              educational: false,
              hasEduTags: false
            })}
            {...(isStartHSE && {
              educational: true,
            })}
          />
        }
        //@ts-ignore
        customTabs={customTabs}
        //@ts-ignore
        newLayout={true}
        //@ts-ignore
        activeTab={activeTabState}
        onTabChange={setActiveTabState}
        topContent={ShouldDisplaySearchBar && (
          <SearchWrapper width={'100%'} widthMobile={'100%'}>
            <NavbarWidget.SearchStatic
              onSearch={(value: any) => consoleSearch(value)}
              key="search-widget"
              mobile
              isMainMobileSearch
            />
          </SearchWrapper>
        )}
      />
      {createButton}
      <BodyLock/>
    </Wrapper>
    </ThemeProvider>
  );
};import React, { FC, useEffect, useCallback, useMemo, useState } from 'react';
import styled, { useTheme, css, createGlobalStyle, ThemeProvider } from 'styled-components';
import {
  FlexBox,
  useIsMobile,
  useBreakpoint,
  ModalMenuContextMobileUI,
  LinkColumn,
  Outer,
  SwitcherContentContainer,
  TabsSwitcherWrapper,
  CustomModalMenuMobileUI,
  Colors,
  SwitcherItem,
  SwitcherContainer,
  LinkBoxWrapper
} from '@brg/ui';
import './ModalMenuContextsMobile.css';
// import { LinkColumn, Outer, SwitcherContentContainer, TabsSwitcherWrapper } from '@brg/ui/dist/ui-modal_menu_context_mobile/component/styled';
// import { TagsSearchScrollWrapper } from '@brg/tags/dist/modals/selectTagsModal/styles.mobile';

import { AuthXService, bProfile, useProfile } from '@brg/auth';
import { ApplicationShared, bURL, LayoutConst, useModal } from 'core';
import { AppTester } from 'supporting';
import { NavbarWidget } from 'shared/components/__FOX__/NAV/src';
import { consoleSearch } from 'shared/helpers/consoleSearch';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import SelectTagsModalContainer from 'shared/modals/selectTagsModal/selectTagsModalContainer';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HseContextSelector } from "../reducers/hseCurrentContext";
import scrollElementIntoView from "../utils/scrollElementIntoView";
import { ExploreButtonFilled } from 'shared/pages/explore/styles';
import useSplitTagsConfig from "../hooks/useSplitTagsConfig";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { useGetMobileMenuSettings } from "../components/navigationSystem/useGetMobileMenuSettings";
import { useContextLinksNew } from "../components/navigationSystem/context/useContextLinksNew";
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { API } from "@brg/api";
import { COUNTRIES } from "../components/navigationSystem/tabs/useDafesTabs";
import { ModalMenuKiiidsCollectionTab } from './ModalMenuKiiidsCollectionTab';
import { createThemeByColor } from 'shared/helpers/coloring';

const TagsSearchScrollWrapper = styled(FlexBox)`
  //height: 100vh;
  height: 100%;
  overflow-y: overlay;
  display: block;
  padding-bottom: 50px !important;

  &::-webkit-scrollbar {
    height: 1px;
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.app?.backgroundColor === '#FEFEFE' ? `${Colors.geoWhite47}` : `${Colors.geoWhite100}`};
  }
`;

export const SearchWrapper = styled(FlexBox)`
  padding: 16px 16px 0px;

  .search-flex-wrapper {
    height: 40px !important;
  }

  .main-searchbar-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 44px !important;
    height: 44px !important;
  }

  .main-searchbar-input-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    padding: 15px 10px 13px 16px !important;
  }

  .icon-wrapper {
    div {
      display: flex;
      height: 100%;
      align-items: center;
    }
  }

  .dropdown-container {
    .search-tabs-wrapper {
      width: 100%;
    }
  }

  .main-searchbar-wrapper__vertical,
  .main-searchbar-wrapper__vertical .main-searchbar-input-wrapper,
  .main-searchbar-wrapper__vertical input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 24px !important;
    height: 24px !important;
  }

  .main-searchbar-results-wrapper {
    z-index: 99999;
    width: 100%;
  }

  .main-searchbar_item {
    z-index: 99999;
    width: 100%;
  }


  @media (max-width: ${LayoutConst.screen.s}px) {
    padding: 16px 16px 0 16px !important;
  }

`;

export const SearchWrapperMobile = styled(FlexBox)`
  padding: 10px 10px 10px;

  .main-searchbar-wrapper, .main-searchbar-input-wrapper, input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 40px !important;
    height: 40px !important;
  }

  .main-searchbar-wrapper__vertical,
  .main-searchbar-wrapper__vertical .main-searchbar-input-wrapper,
  .main-searchbar-wrapper__vertical input {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 24px !important;
    height: 24px !important;
  }

  .main-searchbar-results-wrapper {
    z-index: 99999;
    width: 100%;
  }

  .main-searchbar_item {
    z-index: 99999;
    width: 100%;
  }

`;

const TextBox = styled(FlexBox)`
  row-gap: 16px;
  //&:last-child {
  //    margin-bottom: 150px;
  //}
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
  @media (min-width: ${LayoutConst.screen.s}px) {
    row-gap: 24px;
  }
`;

export const TextItem = styled.span<{ color?: string }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  ${({ color }) => color ? css`
    color: ${color};
  ` : null};

  @media (min-width: ${LayoutConst.screen.s}px) {
    font-size: 34px;
    line-height: 41px;
    letter-spacing: -0.02em;
  }
`;

const CreateButtonWrapper = styled(FlexBox)`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
  height: 76px;
  background-color: #f2f2f2;
  padding: 16px 16px 24px 16px;

  button {
    height: 36px !important;
    width: 100%;
    max-width: 100% !important;
    margin: 0 !important;
  }
`;

const BodyLock = createGlobalStyle`
  body {
    overflow-y: hidden !important;
    position: fixed;
  }
`

const Wrapper = styled.div<{ maxHeight?: number, variant?: 'menuLikeOnGallllery' }>`
  height: 100%;

  .dropdown-list-item, .sc-item {
    border-bottom: 1px solid rgb(205, 205, 205);
  }

  ${Outer} {
    height: calc(100% - 48px);
    z-index: 200001;
  }
;

  ${LinkBoxWrapper}{
  margin-top: ${p => p.variant === 'menuLikeOnGallllery' && '27px'};
  }

  ${LinkColumn} {
    max-height: calc(100vh - ${({ maxHeight }) => maxHeight || 0}px);
    margin-bottom: 0 !important;
  }

  ${SwitcherContentContainer} {
    border-bottom: 1px solid #CDCDCD;
    height: calc(100% - 20px);
    background-color: ${p => p.variant === 'menuLikeOnGallllery' ? '#E7E7E7' : p.theme.app.backgroundColor};

    .sc-item {
      z-index: 0;
    }

    .sc-item:last-child {
      z-index: 0;
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '16px'};

      @media (max-width: ${LayoutConst.screen.s}px){
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};
      }
    }

    a {
      border-bottom: ${p => p.variant === 'menuLikeOnGallllery' ? '1px solid #CDCDCD' : 'none'};

      &:not(:last-child) {
        margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '10px'} !important;
      }

      .sc-dropdown-item, .sc-item{
          margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '16px'};
          padding-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '12px'};
          min-height: ${p => p.variant === 'menuLikeOnGallllery' && '35px'};

          &:last-child {
            margin-bottom: 0 !important;
          }

          @media (max-width: ${LayoutConst.screen.s}px) {
            margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};

            &:not(:last-child) {
              margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '10px'} !important;
            }
          }
      }

          @media (max-width: ${LayoutConst.screen.s}px) {
            &:not(:last-child) {
              margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '7.5px'} !important;
            }
          }
    }
  }

  ${TagsSearchScrollWrapper} {
    height: 100%;
  }

  ${SwitcherContainer} {
    border-bottom: ${p => p.variant === 'menuLikeOnGallllery' ? '1px solid #CDCDCD' : 'none'};
    max-height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    min-height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    height: ${p => p.variant === 'menuLikeOnGallllery' && '46px'};
    margin-top: ${p => p.variant === 'menuLikeOnGallllery' && '8px'};

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    min-height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    height: ${p => p.variant === 'menuLikeOnGallllery' && '32px'};
    }
  }

  ${TabsSwitcherWrapper} {
    height: 100%;
    
    >div >div {
      color: ${p => p.variant === 'menuLikeOnGallllery' && '#909090'};
    }

    &, & .active {
      background-color: ${p => p.variant === 'menuLikeOnGallllery' ? '#E7E7E7' : p.theme.app.backgroundColor};
    }
    .active {
      color: ${p => p.variant === 'menuLikeOnGallllery' && '#151515'};
      border-bottom: 2px solid ${p => p.theme.navigationBar.mobileMenu.item.colorActive};
    }
  }

  .sc-dropdown-item, .sc-item {
    margin-bottom: ${p => p.variant === 'menuLikeOnGallllery' && '0'}; 

    div {
      font-size: 17px;
      line-height: 22px;
    }

    @media (min-width: ${LayoutConst.screen.s}px) {
      border: none;
    } 
    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      margin-left: ${p => p.variant === 'menuLikeOnGallllery' && '0'};
      div {
        font-size: 15px;
        line-height: 20px;
        padding-left: ${p => p.variant === 'menuLikeOnGallllery' && '12px'};
      }
    }
  }
`

/**
 * Модалка для мобильного меню
 * @param props
 * @constructor
 */
export const ModalMenuContextMobileNew: FC<{
  visible?: boolean,
  hseUrls?: any[],
  closeMenu?: () => void,
}> = ({
  hseUrls,
  visible,
  closeMenu,
}) => {

  const { t, i18n: { language } } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const is470 = useBreakpoint(470);
  const isHSEDesign = AppTester.isHSEDesign();
  const isAcademy = AppTester.isAcademy();
  const isDeziiignEssential = AppTester.isDeziiignEssential();
  const isGeograffee = AppTester.isGeograffee();
  const isDvaDesign = AppTester.isDvaDesign();
  const isMedia = AppTester.isMediiia();
  const isGalllleryArt = AppTester.isGalllleryArt();
  const isBooksGallllery = AppTester.isBooksGallllery();
  const isDafes = AppTester.isGeoDafes();
  const isLPU = AppTester.isLPUDesign();
  const isStartHSE = AppTester.isStartHSE();
  const { anchorLinks: anchorLinksRaw } = useSelector(HseContextSelector);
  const profile = useProfile();

  const theme1 = useTheme();

  const anchorLinks: any[] = useMemo(() => {
    //@ts-ignore
    return anchorLinksRaw.map(({ anchorText, postId }) => ({
      //@ts-ignore
      title: anchorText,
      name: anchorText,
      content: anchorText,
      value: '#',
      ctx: '',
      active: false,
      external: false,
      action: (e: any) => {
        closeMenu?.();
        const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`)
        if (element) {
          setTimeout(() => {
            scrollElementIntoView(element, -70);
          }, 300)
        }
      }
    }))
  }, [location, language, anchorLinksRaw])

  const { links: mainLinks } = useContextLinksNew();
  const rightLinks = useGetFilteredTabs(closeMenu);
  const filteredRightLinks = useMemo(() => isDvaDesign ? anchorLinks : rightLinks, [anchorLinks, isDvaDesign, rightLinks])

  const isModer = useMemo(() => (profile && bProfile.isModer(profile)), [profile])
  const filteredMainLinks = useMemo(() => isDvaDesign || isLPU || (isGalllleryArt && !isModer) ? [] : mainLinks, [isDvaDesign, isGalllleryArt, isLPU, isModer, mainLinks]);
  const noDropdown = /*isOnlines || isAgeytomesh || AppTester.isSchool()*/ true;

  const dropdownIsOpen = (isDeziiignEssential || isGeograffee) && !isAcademy
  const { shouldDisplaySplitTags } = useSplitTagsConfig();

  const lowerHseUrls = useMemo(() => hseUrls?.map(url => ({ ...url, title: url?.title?.toLowerCase() })), [hseUrls]);

  const {
    hiddenTabs,
    tabOrder,
    activeTab: initialTab,
    competenciesTabName,
    tagsTabName
  } = useGetMobileMenuSettings(filteredMainLinks, filteredRightLinks)

  const [activeTabState, setActiveTabState] = useState(initialTab);

  const ShouldDisplaySearchBar = getShouldDisplaySearch(activeTabState)

  const hasScroll = useMemo(() => {
    return shouldDisplaySplitTags && ((isHSEDesign && !!hseUrls?.length) || !!anchorLinks?.length);
  }, [shouldDisplaySplitTags, hseUrls, anchorLinks]);

  useEffect((): void => { // запрещаем общий скролл, чтобы шапка не скроллилась
    const body = document.querySelector('body');
    if (body) {
      if (visible) {
        body.style.overflow = "hidden";
      }
      //@ts-ignore
      return () => {
        body.style.overflow = "auto";
      }
    }
  }, [visible])

  const countriesTab = useMemo(() => {
    if (!isDafes) {
      return null;
    }
    const tr = API.lang(COUNTRIES, language);

    return {
      countries: {
        key: 'countries',
        name: language === 'en' ? 'Countries' : 'Страны',
        links: tr.map((item:any) => ({
          title: item.name,
          name: item.name,
          content: item.name,
          value: '#',
          ctx: '',
          active: false,
          external: false,
          isTeam: true,
          action: (e: any) => {
            closeMenu?.();
            history.push(CreateLinkTo.country(item.value))
          }
        }))
      }
    };
  }, [language])

  const customTabs = useMemo(() => {
    return {
      competencies: {
        key: 'competencies',
        name: competenciesTabName,
        component: <SelectTagsModalContainer
          protectedTags={[]}
          isMobileMenu
          onClose={closeMenu}
          mode={'link'}
          hasEduTags
        />,
      },
      ...countriesTab,
      ...(anchorLinks.length && {
        anchors: {
          key: 'anchors',
          name: language === 'en' ? 'Navigation' : 'Навигация',
          links: anchorLinks,
        },
      }),
    }
  }, [anchorLinks, competenciesTabName, countriesTab, language])

  const createButton = useMemo(() => {
    if (isMedia && is470) {
      return (
        <CreateButtonWrapper
          onClick={() => history.push(CreateLinkTo.projectCreate())}
        >
          <ExploreButtonFilled>{t('nav.create_project')}</ExploreButtonFilled>
        </CreateButtonWrapper>
      )
    }
  }, [isMedia, history, t, is470])

  // TODO жесткий временный костыль на скролл табов
  const maxHeight = useMemo(() => {
    return 48 + 36 + 26 + (ShouldDisplaySearchBar ? 60 : 0) + (createButton ? 76 : 0) + 110
  }, [ShouldDisplaySearchBar, createButton])

  if (!visible) {
    return null;
  }
  console.log('activeTabState:', activeTabState);
  return (
    <ThemeProvider theme={theme1}>
    <Wrapper maxHeight={maxHeight} variant={isBooksGallllery ? 'menuLikeOnGallllery' : undefined}>
      <ModalMenuContextMobileUI
        hasScroll={hasScroll}
        hasNoDropDown={Boolean(noDropdown)}
        isOpenedDropDown={dropdownIsOpen}
        tabOrder={tabOrder}
        mainLinks={filteredMainLinks}
        customTabNames={{
          tags: tagsTabName,
          laboratory: t('mobile_menu.laboratory'),
          menu: t('mobile_menu.menu'),
          main: isBooksGallllery ? t('mobile_menu.catalog') : t('mobile_menu.main'),
        }}
        hiddenTabs={hiddenTabs}
        leftLinks={[]}
        rightLinks={filteredRightLinks}
        //@ts-ignore
        dropdownLinks={isHSEDesign ? lowerHseUrls : undefined}
        tags={
          <SelectTagsModalContainer
            protectedTags={[]}
            isMobileMenu
            mode={'link'}
            onClose={closeMenu}
            {...(shouldDisplaySplitTags && !isStartHSE && {
              educational: false,
              hasEduTags: false
            })}
            {...(isStartHSE && {
              educational: true,
            })}
          />
        }
        //@ts-ignore
        customTabs={customTabs}
        //@ts-ignore
        newLayout={true}
        //@ts-ignore
        activeTab={activeTabState}
        onTabChange={setActiveTabState}
        topContent={ShouldDisplaySearchBar && (
          <SearchWrapper width={'100%'} widthMobile={'100%'}>
            <NavbarWidget.SearchStatic
              onSearch={(value: any) => consoleSearch(value)}
              key="search-widget"
              mobile
              isMainMobileSearch
            />
          </SearchWrapper>
        )}
      />
      {createButton}
      <BodyLock/>
    </Wrapper>
    </ThemeProvider>
  );
};